export const INITIAL_POWER = 120;
